const helpers = {
    applyStyles: (clientStyles) => {
        for(var key in clientStyles){
            document.documentElement.style.setProperty('--'+key, clientStyles[key]);
        }
    }
}

export default helpers